<template>
    <div>
        <h3>Prämie berechnen</h3>
        <div id="webchat"></div>
    </div>
</template>

<script>
export default {
    props: ['fields'],
    data() {
        return {
            token: '',
            conversationId: ''
        }
    },
    created() {
        this.getToken();
    },
    methods: {
        getToken() {
            let self = this;
            fetch('https://janitos.de/api/limoncello-chatbot/directline/token')
            .then(response => { response.json().then(
                function(data) {
                    self.token = data.token;
                    self.conversationId = data.conversationId;
                    self.startBot();
                });
            });
        },
        startBot() {
            let self = this;
            (async function() {
        	    const store = window.WebChat.createStore({},({ dispatch }) => next => action => {
                    if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
                        dispatch({
                            type: 'WEB_CHAT/SEND_EVENT',
                            channelData: {
                                channelId: "janitos"
                            },
                            payload: {
                                name: "janitos",
                                value: {
                                    zip_code: self.fields.zipcode,
                                    bike_type: self.fields.bikeType,
                                    price: self.fields.price
                                }
                            }
                        });
                    }
                    if (action.type === 'DIRECT_LINE/POST_ACTIVITY_FULFILLED') {
                        window.scrollTo(0,document.body.scrollHeight);
                    }
                    return next(action);
                });
                window.WebChat.renderWebChat(
                {
                    directLine: window.WebChat.createDirectLine({
                    token: self.token
                }),
                    store
                },
                    document.getElementById('webchat')
                );

                document.querySelector('#webchat > *').focus();
            })().catch(err => console.error(err));
        },
        getUrlParameter(name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search)||[""])[1].replace(/\+/g, '%20'))||null;
        },
    }
}
</script>
